<template>
<div class="marker" v-tooltip="{
  content: tooltipcontent,
  classes: ['info'],
}">
    <div class="icon-label" @click="onClick()"><p><b>{{index + 1}}</b></p></div>
</div>
</template>

<script>



const mapMarker = require('../../assets/mapmarker.svg');

export default {

  name: 'DealerPreview',
  props: ['index', 'title', 'dealer'],
  data: function() {
    return {
      tooltipcontent: "",
      mdealer: null
    }
  },
  methods: {
    onClick: function(){
      this.$emit("mapMarkerClicked", this.index);
    },
    setTooltip: function() {
      let services = [];

      this.tooltipcontent = "<span style=\"font-size:1.1em;\">" + this.title + "</span></br>"

      if(this.dealer.haendler=='True'){
        services.push('Verkauf');
      }
      if(this.dealer.vermieter=='True'){
        services.push('Vermietung');
      }
      if(this.dealer.servicepartner=='True'){
        services.push('Service');
      }

      for(let i in services){
        this.tooltipcontent += "<div class=\"ui tiny label\" style=\" background-color: #e8e8e8;\">" + this.$t(services[i]) + "</div>" ;
      }


    }
  },
  created() {
    this.mdealer = this.dealer;
    this.setTooltip();

  },
  watch: {
    dealer(newValue, oldValue) {
      this.mdealer = newValue;
      this.setTooltip();
    }
  }
}

</script>

<style>

.marker{
  color:white;
  width: 30px;
  height: 30px;
  text-decoration: none;
}

.marker:hover{
  cursor: pointer;
}
.marker p{
  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
  font-size: 12px;
  font-weight: 700;
  width: 100%;
  width: 100%;
  text-align: center;
  line-height: 28px;
  color: white;

}
.icon-label{
  width: 30px;
  height: 30px;
  left: 0;
  background-image: url('https://www.rewaco.com/typo3conf/ext/site_base/Resources/Public/images/mapmarker.svg');
  top: 0;
}



</style>
